import { render, staticRenderFns } from "./LfsRadioBoxType.vue?vue&type=template&id=db062032&scoped=true&"
import script from "./LfsRadioBoxType.vue?vue&type=script&lang=ts&"
export * from "./LfsRadioBoxType.vue?vue&type=script&lang=ts&"
import style0 from "./LfsRadioBoxType.vue?vue&type=style&index=0&id=db062032&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db062032",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
installComponents(component, {VRadio,VRadioGroup})
